<template>
  <section class="pb-8" id="ebook">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">Receba o e-book!</h1>
              <h3 class="font-weight-light mt-3 text-justify">
                Para ajudar você a dar os primeiros passos nos seus preparos pré-viagem, disponibilizamos <span class="font-weight-bold">gratuitamente</span>  
                o e-book <span class="font-weight-bold">"Guia prático - Como se preparar para viagens longas"</span> que apresentará exercícios, prevenção de dores, dicas para arrumar as malas e o que fazer caso você sinta dor durante a viagem. 
                É só solicitar no campo ao lado que você receberá o e-book em seu e-mail de forma rápida e gratuita.
              </h3>
              <!-- <h3 class="font-weight-light mt-3">
                Lorem ipsum dolor sit amet consectetur adipisicing.
              </h3> -->
            </v-col>
            <v-col cols="12" sm="7">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="* Nome"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="* Email"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="phone"
                    label="Telefone"
                    required
                />
                
                <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    class="mt-3"
                    @click="submit"
                >
                Enviar
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="dialogSending"
      width="100"
      persistent
    >
     
      <v-card>
        <v-card-text style="padding-top: 20px; padding-left: 35px;">
          <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
        </v-card-text>

        <v-divider></v-divider>

        
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSuccess"
      width="500"
      persistent
    >
     
      <v-card>
        <v-card-title
          class="headline white lighten-2"
          primary-title
        >
        <p class="font-weight-strong display-1">Email enviado com sucesso!</p>
        </v-card-title>


        <v-card-text>
           <h2>Caso não receba em 1 minuto, verifique sua caixa de spam.</h2>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="closeDialogSuccess"
          >
            Entendi!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogError"
      width="500"
      persistent
    >
     
      <v-card>
        <v-card-title
          class="headline white lighten-2"
          primary-title
        >
        <p class="font-weight-strong display-1">Erro ao enviar email!</p>
        </v-card-title>


        <v-card-text>
           <h2>Tente novamente mais tarde.</h2>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialogError = false"
          >
            Voltar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <v-snackbar
        v-model="snackbar.enabled"
        timeout="3000"
        right
        top
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>


<style scoped>
#ebook {
  background-color: #fff;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
// import {db} from '@/main'

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "O campo nome é necessário",
      (v) => (v && v.length >= 4) || "O nome precisa ter mais de 3 letras",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "O campo email é necessário",
      (v) => /.+@.+\..+/.test(v) || "Digite um email valido",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "The text field is required",
      (v) => (v && v.length >= 10) || "Minimum 10 characters",
    ],
    phone: "",
    phoneRules : [],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    },
    dialogSuccess: false,
    dialogSending: false,
    dialogError: false
  }),
  methods: {

    closeDialogSuccess() {
      this.dialogSuccess = false;
      this.$vuetify.goTo('#hero')
    },

    fakesubmit() {
      // alert("Email enviado com sucesso! Caso não receba em 1 minuto, verifique sua caixa de spam.")
      this.dialogSuccess = true;
    },
    submit() {
      this.dialogSending = true;

      const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", "origin": "https://www.fisioviajante.com.br", "Access-Control-Allow-Origin": "*", "Access-Control-Allow-Credentials": true },
      body: JSON.stringify({
                "from_address": "",
                "from_name": "Fisio Viajante",
                "to_phone": this.phone,
                "to_name": this.name,
                "to_address": this.email,
                "email_subject": "Aqui está seu e-book!"
        })
    };

    fetch('https://bvzmo7wvu2.execute-api.eu-north-1.amazonaws.com/sendMail', requestOptions)
    .then(async response => {
      const data = await response.json();
      this.dialogSending = false;
      Promise.reject(null)
      // check for error response
      if (!response.ok) {
        // get error message from body or default to response status
        const error = (data && data.message) || response.status;
        console.error(error)
        return Promise.reject(error);
      }
      this.dialogSuccess = true;

    })
    .catch(error => {
      this.dialogSending = false;
      this.errorMessage = error;
      console.error('There was an error!', error);
      dialogError = true;
      alert("erro");
[]    });
      // .then(response => response.json())
      // .then(data => (this.postId = data.id));



    //   this.$loadScript("https://smtpjs.com/v3/smtp.js")
    //     .then(() => { 
    //       window.Email && window.Email.send({
    //             Host : "smtp.gmail.com",
    //             Username : "fisioviajante@gmail.com",
    //             Password : "THCD4F4DBDB3DBD328694F14F0C9E0D568A3",
    //             To : this.email,
    //             From : 'fisioviajante@gmail.com',
    //             Subject : this.name,
    //             Body : this.textArea,
    //         }).then(
    //           textArea => alert(textArea)
    //         );
    //     })
    //     .catch(() => {
    //     // Failed to fetch script
    // })}
    }
  }
};
</script>
